import { useProjectPermissions } from 'hooks/useProjectPermissions'
import Checkbox from 'ui/components/forms/Checkbox'
import Input from 'ui/components/forms/Input/'
import { useUpdateGanttLink } from '../../../../hooks'
import Form from '../../../Form'

const GanttForm = ({ gantt, onCancel }) => {
  const { projectSlug } = useProjectPermissions()
  const { formik, isLoading } = useUpdateGanttLink(gantt, projectSlug)

  return (
    <Form
      onSubmit={async () => {
        await formik.submitForm()

        if (!formik.isValid) return false

        onCancel()
        return true
      }}
      onCancel={onCancel}
      onReset={() => formik.resetForm()}
      isSubmitting={isLoading}
      renderFields={() => (
        <>
          <Input
            id="editLinkInput"
            placeholder="https://"
            name="link"
            isClearable={true}
            meta={formik.getFieldMeta('link')}
            {...formik.getFieldProps('link')}
            onChange={(e) => {
              formik.setFieldValue('link', e?.target?.value ?? '')
            }}
          />
          <Checkbox
            label="План доступен по паролю"
            name="isProtected"
            checked={formik.values.isProtected}
            onChange={formik.handleChange}
          />
        </>
      )}
    />
  )
}

export default GanttForm
